export function Nav(): JSX.Element {
  return (
    <nav className="nav" aria-hidden="true">
      <div className="container">
        <div className="nav__inner" />
      </div>
    </nav>
  );
}
